import {createRouter, createWebHashHistory} from '@ionic/vue-router';
import {RouteRecordRaw} from 'vue-router';
import {inject} from "vue";
import {IAuthPlugin} from "@/plugins/auth/auth";
import mitt from "mitt";


const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        redirect: '/workspaces'
    },
    {
        path: '/login',
        name: 'Iniciar sesión',
        component: () => import('@/pages/LoginPage.vue')
    },
    {
        path: '/workspaces',
        name: 'Espacios',
        component: () => import('@/pages/WorkspacePage.vue')
    },
    {
        path: '/workspace/:workspaceId',
        name: 'Inicio',
        component: () => import('@/pages/StartWorkspacePage.vue')
    },
    {
        path: '/workspace/:workspaceId/cursos',
        name: "Lista de cursos",
        component: () => import('@/pages/CoursesPage.vue')
    },
    {
        path: '/courses/:courseId',
        name: "Temario del curso",
        component: () => import('@/pages/TopicsPage.vue')
    },
    {
        path: '/esquema/:restOfPath(.*)',
        name: "Esquema",
        component: () => import('@/pages/SchemePage.vue')
    },
    {
        path: '/test/:testId',
        name: 'Test',
        component: () => import('@/pages/TestPage.vue')
    },
    {
        path: '/test/:testId/modo-grabacion',
        name: 'Modo grabación',
        component: () => import('@/pages/ModoGrabacionTestPage.vue')
    },
    {
        path: '/notificaciones/:workspaceId',
        name: 'Notificaciones',
        component: () => import('@/pages/NotificationDashboard.vue')
    },
    {
        path: '/politica-de-privacidad',
        name: 'Política de privacidad',
        component: () => import('@/pages/PrivacyPolicyPage.vue')
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: () => import('@/pages/NotFoundPage.vue')
    }
]

const router = createRouter({
    history: createWebHashHistory(import.meta.env.BASE_URL),
    routes
})


router.beforeEach((to, from, next) => {

    const auth = inject('auth') as IAuthPlugin;

    auth.isAuthenticated().then((isAuthenticated: boolean) => {

        console.debug("Está autenticado: " + isAuthenticated);

        if (!isAuthenticated && to.path !== '/login') {
            console.debug('No está autenticado. Redireccion al login.');
            console.debug(import.meta.env.VITE_APP_TITLE);
            return next('/login');
        }
        next();
    }).catch((error) => {
        console.error(error);
        next('/login');
    });
});

export default router;

export const emitter = mitt();

